<nav class="navbar custom-navbar bg-faded main-header px-3">

    <a href="javascript:;" class="nav-link ps-0 d-lg-none mobile-menu-toggle" (click)="toggleSidenav.emit()">
      <i class="icon ion-android-menu"></i>
    </a>

    <span class="navbar-heading me-3">{{heading}}</span>


    <span class="ms-auto"></span>

    <div class="checkin-link">
      <button class="btn custom-btn" (click)="openCheckInModal(chekInModal)"
        *ngIf="!(userType == 'nutrition' || userType == 'sales' || userType == 'salesmanager')">Check In</button>
    </div>

    <div ngbDropdown display="dynamic" >
      <button class="btn btn-link" id="dropdownBasic1" ngbDropdownToggle>Admin</button>
      <div ngbDropdownMenu aria-labelledby="dropdownBasic1" class="dropdown">
        <!-- <button class="btn btn-link" (click)="toUserProfile()" ngbDropdownItem> <i class="fas fa-user"></i> &nbsp; My Profile</button> -->
        <!-- <div class="dropdown-divider"> -->
        <!-- <button class="btn btn-link" ngbDropdownItem><i class="fas fa-lock"></i> &nbsp; Lock</button> -->
        <button class="btn btn-link" (click)="integrateWithOutlook()" ngbDropdownItem *ngIf="userType == 'trainer' || userType == 'headtrainer'">
        <i class="fas fa-retweet"></i> &nbsp;
        Integrate with Outlook</button>
        <button class="btn btn-link" (click)="changePassword(changePasswordModal)" ngbDropdownItem><i
            class="fas fa-lock"></i> &nbsp;
          Change Password</button>
        <button class="btn btn-link" (click)="logout()" ngbDropdownItem><i class="fas fa-sign-out-alt"></i> &nbsp;
          Logout</button>
        <!-- </div> -->
      </div>
    </div>

</nav>
<ng-template #chekInModal let-close="close">
  <div class="modal-header">
    <h3 class="modal-title" ngbAutofocus >Check in</h3>
    <button type="button" class="btn-close" aria-label="Close" (click)="closeCheckInModal()">
    </button>
  </div>
  <div class="modal-body">
    <div class="d-flex justify-content-center align-items-center h-100">
      <div class="card-body">
        <div class="row">
          <div class="col-12 text-center check-by">
            <h4 (click)="checkInWay('manual')" class="upperCase">Manual check In</h4>
          </div>
        </div>
        <div class="row check-in-way" [ngClass]="{'manual': wayToCheckIn=='manual'}">
          <div class="col-12">
            <!-- <form #chekInForm> -->
              <div class="row">
                <div class="col-12">
                  <fieldset class="form-group mb-4">
                    <input type="text" name="user_code" [(ngModel)]="checkedInCode" class="form-control"
                      placeholder="user code" required />
                  </fieldset>
                </div>
              </div>
              <div class="row">
                <div class="col-12 text-center">
                  <button type="submit" class="btn custom-btn px-3 w-50 m-auto" (click)="CheckInUser()">Check
                    in</button>
                </div>
              </div>
            <!-- </form> -->
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="or-divider">
              <span>OR</span>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 text-center check-by">
            <h4 (click)="checkInWay('camera')" class="upperCase">Camera check In</h4>
          </div>
        </div>
        <div class="row check-in-way" [ngClass]="{'camera': wayToCheckIn=='camera'}">
          <div class="col-12">
            <div class="camera-check-in">
              <div *ngIf="!cameraAvailable" class="alert alert-warning text-center">
                Camera access is not available on this device or browser. Please use manual check-in.
              </div>
              
              <!-- Simplified scanner component with minimal props -->
              <zxing-scanner 
                *ngIf="wayToCheckIn=='camera' && cameraAvailable" 
                [enable]="scannerEnabled"
                (scanSuccess)="scanSuccess($event)"
                (permissionResponse)="onHasPermission($event)"
                (scanError)="onCameraError($event)"
              ></zxing-scanner>
              
              <div *ngIf="wayToCheckIn=='camera' && !hasCameraPermission && cameraAvailable" class="mt-3 text-center">
                <p>Camera permission is required to scan codes.</p>
                <button class="btn btn-warning mt-2" (click)="wayToCheckIn = 'manual'">
                  Use Manual Entry Instead
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bg-cover"></div>
    </div>
  </div>
</ng-template>

<ng-template #changePasswordModal let-close="close">
  <div class="modal-header">
    <h3 class="modal-title" ngbAutofocus >Change Password</h3>
    <button type="button"  class="btn-close" aria-label="Close" (click)="closeChangePasswordModal()">
    </button>
  </div>
  <div class="modal-body">
    <div class="d-flex justify-content-center align-items-center h-100">
      <div class="card-body">
        <form [formGroup]="changePasswordForm" (ngSubmit)="changePasswordSubmit()">
          <div class=" text-center">
            <div class=" row">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Old Password</mat-label>
                <input matInput type="password" placeholder="********" formControlName="old_password">
              </mat-form-field>
            </div>
            <div class="row ">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>New Password</mat-label>
                <input matInput type="password" placeholder="********" formControlName="new_password">
              </mat-form-field>
            </div>
            <div class="row ">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Confirm Password</mat-label>
                <input matInput type="password" placeholder="********" formControlName="confirm_password">
              </mat-form-field>
            </div>
          </div>

          <div class="d-flex justify-content-center mt-4 mb-4">
            <button class="btn custom-btn mt-2" style="padding: 10px 20px;" type="submit"
              [disabled]="!changePasswordForm.valid || changePasswordLoadingFlag">{{changePasswordLoadingFlag? 'Loading...':'Change'}}</button>
          </div>
        </form>

      </div>
      <div class="bg-cover"></div>
    </div>
  </div>
</ng-template>
